import "core-js/modules/es6.function.name";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  device: function device(state) {
    return state.app.device;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  loading: function loading(state) {
    return state.settings.loading;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  companyList: function companyList(state) {
    return state.user.companyList;
  },
  // 公司列表
  sellUsersList: function sellUsersList(state) {
    return state.user.sellUsersList;
  },
  // 销售人员列表
  operateUserList: function operateUserList(state) {
    return state.user.operateUserList;
  },
  // 运营人员
  organizeList: function organizeList(state) {
    return state.user.organizeList;
  },
  // 组织列表
  userInfo: function userInfo(state) {
    return state.user.userInfo;
  },
  // 用户信息
  menus: function menus(state) {
    return state.user.menus;
  },
  // 菜单信息
  head: function head(state) {
    return state.user.head;
  },
  // 用户头像
  serviceName: function serviceName(state) {
    return state.user.serviceName;
  },
  // 当班客服
  domainName: function domainName(state) {
    return state.user.domainName;
  },
  // 当前域名
  monthList: function monthList(state) {
    return state.user.monthList;
  } // 当前域名
};
export default getters;